import { render, staticRenderFns } from "./ProductSinglePrice.vue?vue&type=template&id=1f1050b6&"
import script from "./ProductSinglePrice.vue?vue&type=script&lang=js&"
export * from "./ProductSinglePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports